module.exports = __webpack_public_path__ + "img/audit.f83beeca.png";